import { useCallback } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const UserInfo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const sid = searchParams.get("sid");

  const apiBaseURL =
    process.env.REACT_APP_API_URL === undefined
      ? "http://localhost:5000"
      : process.env.REACT_APP_API_URL;

  const getUserInfo = useCallback(async () => {
    if (!id || !sid) {
      navigate("/404");
      return;
    }

    try {
      const response = await axios.get(
        `${apiBaseURL}/api/v1/name-card/display/${id}?sid=${encodeURIComponent(
          sid
        )}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      navigate("/404");
    }
  }, [id, sid, apiBaseURL, navigate]);

  return {
    getUserInfo,
  };
};

export default UserInfo;
